var _style, _g, _polygon, _polygon2, _rect, _g2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg917Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 46",
    style: {
      enableBackground: "new 0 0 200 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4883B0;}\r\n\t.st1{fill:#160000;}\r\n\t.st2{fill:#717070;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.2,15.6h10.6v1h-9.3v6.9h8.5v1h-8.5v7.3h9.7v1h-11V15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,15.6h1.3l11.4,15.5V15.6h1.2v17.3h-1.3l-11.4-15.5v15.5H111V15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.2,16.6h-6.3v-1.1h13.8v1.1h-6.3v16.2h-1.3V16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.8,26.4c0,4-3,6.8-7.1,6.8c-4.1,0-7.2-2.8-7.2-6.8V15.6h1.3v10.8c0,3.4,2.5,5.8,5.9,5.8 c3.4,0,5.9-2.4,5.9-5.8V15.6h1.3V26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.7,15.6h6.2c3.1,0,5.4,2.1,5.4,5c0,2.7-1.8,4.6-4.6,4.9l5.2,7.4h-1.4l-5.1-7.3H162v7.3h-1.2V15.6z  M162,24.6h4.8c2.5,0,4.3-1.6,4.3-4c0-2.3-1.8-4-4.3-4H162V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.8,15.6h10.6v1h-9.3v6.9h8.5v1h-8.5v7.3h9.7v1h-11V15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.1,15.3c1.6,0,3.4,0.4,5.3,1.2l-0.3,1c-1.7-0.7-3.4-1.1-4.9-1.1c-2.8,0-4.6,1.4-4.6,3.4 c0,5.2,10.4,2.5,10.4,9c0,2.7-2.4,4.5-5.9,4.5c-1.7,0-3.8-0.5-5.9-1.4l0.3-1c2,0.8,3.9,1.3,5.5,1.3c2.9,0,4.7-1.4,4.7-3.5 c0-5.4-10.5-2.6-10.5-9C188.3,17.1,190.7,15.3,194.1,15.3z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "80.4,31.2 71.1,5 70.8,5 66.3,16.1 76.2,41.7 85.1,41.7 99.3,5 90.5,5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "42.7,5 42.7,12.4 58.1,12.4 45.6,41.4 55.5,41.4 66.3,16.1 61.8,5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 5,
    className: "st1",
    width: 9,
    height: 36.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.7,4.3C5.7,4.3,0,9.7,0,17.3c0,7,5,11.9,12.1,11.9c2.9,0,5.5-0.9,7.5-2.5c-0.4,5-3.6,7.9-8.1,7.9 c-1.6,0-3.4-0.4-5.2-1.1l-4.9,6C4.9,41.3,8.6,42,11.9,42c10.3,0,16.6-7.5,16.6-20.3C28.6,10.8,23,4.3,13.7,4.3z M14,22.3 c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4s5.4,2.4,5.4,5.4c0,1-0.3,2-0.8,2.8c0,0,0,0,0,0c-0.1,0.1-0.1,0.2-0.2,0.3 c0,0-0.1,0.1-0.1,0.1C17.3,21.4,15.7,22.3,14,22.3z"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.8,5 66.3,16.1 71,5 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg917Logo);
export default __webpack_public_path__ + "static/media/917_logo.ad4d0533b96e1f38bc5099dda9e1b70b.svg";
export { ForwardRef as ReactComponent };